import React from 'react';
import { ButtonMembership, Dialog, T } from '@colonist/ui';
import { emptyTranslation } from '@colonist/i18n';
export const ItemInfoDialog = ({ open, onClose, title, imageUrl, description, onSubscribe })=>/*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(Dialog.ImageTitle, {
        image: {
            src: imageUrl,
            alt: emptyTranslation
        }
    }, /*#__PURE__*/ React.createElement(T, {
        id: title
    }))), description && /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: description
        }
    })), onSubscribe && /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(ButtonMembership, {
        variant: "premium",
        size: "md",
        fullWidth: true,
        onClick: onSubscribe
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.becomeAMember.buttonNames.subscribe'
        }
    }))));
